import { DECADE_UNIT_DIFF } from '../panels/DecadePanel/index';
export var WEEK_DAY_COUNT = 7;
export function isNullEqual(value1, value2) {
  if (!value1 && !value2) {
    return true;
  }

  if (!value1 || !value2) {
    return false;
  }

  return undefined;
}
export function isSameDecade(generateConfig, decade1, decade2) {
  var equal = isNullEqual(decade1, decade2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  var num1 = Math.floor(generateConfig.getYear(decade1) / 10);
  var num2 = Math.floor(generateConfig.getYear(decade2) / 10);
  return num1 === num2;
}
export function isSameYear(generateConfig, year1, year2) {
  var equal = isNullEqual(year1, year2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getYear(year1) === generateConfig.getYear(year2);
}
export function getQuarter(generateConfig, date) {
  var quota = Math.floor(generateConfig.getMonth(date) / 3);
  return quota + 1;
}
export function isSameQuarter(generateConfig, quarter1, quarter2) {
  var equal = isNullEqual(quarter1, quarter2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return isSameYear(generateConfig, quarter1, quarter2) && getQuarter(generateConfig, quarter1) === getQuarter(generateConfig, quarter2);
}
export function isSameMonth(generateConfig, month1, month2) {
  var equal = isNullEqual(month1, month2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return isSameYear(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2);
}
export function isSameDate(generateConfig, date1, date2) {
  var equal = isNullEqual(date1, date2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getYear(date1) === generateConfig.getYear(date2) && generateConfig.getMonth(date1) === generateConfig.getMonth(date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2);
}
export function isSameTime(generateConfig, time1, time2) {
  var equal = isNullEqual(time1, time2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2);
}
export function isSameWeek(generateConfig, locale, date1, date2) {
  var equal = isNullEqual(date1, date2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
}
export function isEqual(generateConfig, value1, value2) {
  return isSameDate(generateConfig, value1, value2) && isSameTime(generateConfig, value1, value2);
}
/** Between in date but not equal of date */

export function isInRange(generateConfig, startDate, endDate, current) {
  if (!startDate || !endDate || !current) {
    return false;
  }

  return !isSameDate(generateConfig, startDate, current) && !isSameDate(generateConfig, endDate, current) && generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
export function getWeekStartDate(locale, generateConfig, value) {
  var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
  var monthStartDate = generateConfig.setDate(value, 1);
  var startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
  var alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);

  if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) {
    alignStartDate = generateConfig.addDate(alignStartDate, -7);
  }

  return alignStartDate;
}
export function getClosingViewDate(viewDate, picker, generateConfig) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  switch (picker) {
    case 'year':
      return generateConfig.addYear(viewDate, offset * 10);

    case 'quarter':
    case 'month':
      return generateConfig.addYear(viewDate, offset);

    default:
      return generateConfig.addMonth(viewDate, offset);
  }
}
export function formatValue(value, _ref) {
  var generateConfig = _ref.generateConfig,
      locale = _ref.locale,
      format = _ref.format;
  return typeof format === 'function' ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}
export function parseValue(value, _ref2) {
  var generateConfig = _ref2.generateConfig,
      locale = _ref2.locale,
      formatList = _ref2.formatList;

  if (!value || typeof formatList[0] === 'function') {
    return null;
  }

  return generateConfig.locale.parse(locale.locale, value, formatList);
}
var TIME_FORMAT_TOKEN = /^(H{1,2}|h{1,2}|k{1,2}|K{1,2}|m{1,2}|s{1,2}|S{1,3}|A|a)/;
/** Split datetime format string into date and time format parts */

export function splitDateTimeFormat(format) {
  var timeStart = -1;
  var i = 0;

  while (i < format.length) {
    if (format[i] === '[') {
      var closeIdx = format.indexOf(']', i);
      i = closeIdx === -1 ? format.length : closeIdx + 1;
      continue;
    }

    var tokenMatch = format.slice(i).match(TIME_FORMAT_TOKEN);

    if (tokenMatch) {
      timeStart = i;
      break;
    }

    if (/[A-Za-z]/.test(format[i])) {
      var tokenChar = format[i];

      while (i < format.length && format[i] === tokenChar) {
        i += 1;
      }

      continue;
    }

    i += 1;
  }

  if (timeStart === -1) {
    return {
      dateFormat: format,
      timeFormat: ''
    };
  }

  var dateFormat = format.slice(0, timeStart).replace(/[\s\-/.,，。:：T]+$/g, '');
  var timeFormat = format.slice(timeStart).replace(/^[\s\-/.,，。:：T]+/g, '');
  return {
    dateFormat: dateFormat,
    timeFormat: timeFormat
  };
}

function consumeFormatTokenInText(text, start, token) {
  if (token === 'YYYY') {
    var _text$slice$match, _text$slice$match$;

    return ((_text$slice$match = text.slice(start).match(/^\d{1,4}/)) === null || _text$slice$match === void 0 ? void 0 : (_text$slice$match$ = _text$slice$match[0]) === null || _text$slice$match$ === void 0 ? void 0 : _text$slice$match$.length) || 0;
  }

  if (token === 'YY') {
    var _text$slice$match2, _text$slice$match2$;

    return ((_text$slice$match2 = text.slice(start).match(/^\d{1,2}/)) === null || _text$slice$match2 === void 0 ? void 0 : (_text$slice$match2$ = _text$slice$match2[0]) === null || _text$slice$match2$ === void 0 ? void 0 : _text$slice$match2$.length) || 0;
  }

  if (['MM', 'DD', 'HH', 'hh', 'mm', 'ss', 'WW', 'ww', 'SS', 'SSS'].includes(token)) {
    var _text$slice$match3, _text$slice$match3$;

    return ((_text$slice$match3 = text.slice(start).match(/^\d{1,3}/)) === null || _text$slice$match3 === void 0 ? void 0 : (_text$slice$match3$ = _text$slice$match3[0]) === null || _text$slice$match3$ === void 0 ? void 0 : _text$slice$match3$.length) || 0;
  }

  if (['M', 'D', 'H', 'h', 'm', 's', 'S'].includes(token)) {
    var _text$slice$match4, _text$slice$match4$;

    return ((_text$slice$match4 = text.slice(start).match(/^\d{1,2}/)) === null || _text$slice$match4 === void 0 ? void 0 : (_text$slice$match4$ = _text$slice$match4[0]) === null || _text$slice$match4$ === void 0 ? void 0 : _text$slice$match4$.length) || 0;
  }

  if (token === 'A' || token === 'a') {
    var _text$slice$match5, _text$slice$match5$;

    return ((_text$slice$match5 = text.slice(start).match(/^(AM|PM|am|pm|[APap])/)) === null || _text$slice$match5 === void 0 ? void 0 : (_text$slice$match5$ = _text$slice$match5[0]) === null || _text$slice$match5$ === void 0 ? void 0 : _text$slice$match5$.length) || 0;
  }

  if (/^M{3,4}$/.test(token)) {
    var _text$slice$match6, _text$slice$match6$;

    return ((_text$slice$match6 = text.slice(start).match(/^[A-Za-z\u4e00-\u9fa5]+/)) === null || _text$slice$match6 === void 0 ? void 0 : (_text$slice$match6$ = _text$slice$match6[0]) === null || _text$slice$match6$ === void 0 ? void 0 : _text$slice$match6$.length) || 0;
  }

  return 0;
}

function findDateTextLength(text, dateFormat) {
  var textIdx = 0;
  var formatIdx = 0;

  while (formatIdx < dateFormat.length && textIdx <= text.length) {
    var formatChar = dateFormat[formatIdx];

    if (formatChar === '[') {
      var closeIdx = dateFormat.indexOf(']', formatIdx);
      var literal = dateFormat.slice(formatIdx + 1, closeIdx);

      if (text.slice(textIdx, textIdx + literal.length) === literal) {
        textIdx += literal.length;
      }

      formatIdx = closeIdx + 1;
      continue;
    }

    if (/[A-Za-z]/.test(formatChar)) {
      var tokenStart = formatIdx;
      var tokenChar = formatChar;

      while (formatIdx < dateFormat.length && dateFormat[formatIdx] === tokenChar) {
        formatIdx += 1;
      }

      textIdx += consumeFormatTokenInText(text, textIdx, dateFormat.slice(tokenStart, formatIdx));
      continue;
    }

    if (textIdx < text.length && (text[textIdx] === formatChar || /\s/.test(formatChar) && /\s/.test(text[textIdx]))) {
      textIdx += 1;
    }

    formatIdx += 1;
  }

  return textIdx;
}
/** Calculate placeholder length of a date format string (year/month/day tokens + literals) */


function getFormatPlaceholderLength(dateFormat) {
  var length = 0;
  var i = 0;

  while (i < dateFormat.length) {
    if (dateFormat[i] === '[') {
      var closeIdx = dateFormat.indexOf(']', i);

      if (closeIdx === -1) {
        length += dateFormat.length - i - 1;
        break;
      }

      length += closeIdx - i - 1;
      i = closeIdx + 1;
      continue;
    }

    if (/[A-Za-z]/.test(dateFormat[i])) {
      var tokenStart = i;
      var tokenChar = dateFormat[i];

      while (i < dateFormat.length && dateFormat[i] === tokenChar) {
        i += 1;
      }

      length += i - tokenStart;
      continue;
    }

    length += 1;
    i += 1;
  }

  return length;
}
/** Get max input length for date part based on format placeholder lengths */


export function getDateInputMaxLength(format) {
  var _splitDateTimeFormat = splitDateTimeFormat(format),
      dateFormat = _splitDateTimeFormat.dateFormat;

  return getFormatPlaceholderLength(dateFormat);
}
/** Get max input length for time part based on format placeholder lengths */

export function getTimeInputMaxLength(format) {
  var _splitDateTimeFormat2 = splitDateTimeFormat(format),
      timeFormat = _splitDateTimeFormat2.timeFormat;

  if (!timeFormat) {
    return undefined;
  }

  return getFormatPlaceholderLength(timeFormat);
}
/** Extract date and time text from input text based on format */

export function extractDateTimeText(text, format) {
  var _splitDateTimeFormat3 = splitDateTimeFormat(format),
      dateFormat = _splitDateTimeFormat3.dateFormat,
      timeFormat = _splitDateTimeFormat3.timeFormat;

  if (!timeFormat) {
    return {
      dateText: text.trim(),
      timeText: ''
    };
  }

  var dateTextLen = findDateTextLength(text, dateFormat);
  return {
    dateText: text.slice(0, dateTextLen).trim(),
    timeText: text.slice(dateTextLen).trim()
  };
}
export function getDateTimeTextsFromFormat(text, format, _ref3) {
  var generateConfig = _ref3.generateConfig,
      locale = _ref3.locale,
      formatList = _ref3.formatList;

  if (typeof format !== 'string') {
    var parts = text.split(/\s+/);
    return {
      dateText: parts[0] || '',
      timeText: parts.slice(1).join(' ')
    };
  }

  var parsed = parseValue(text, {
    generateConfig: generateConfig,
    locale: locale,
    formatList: formatList
  });

  if (parsed) {
    var _splitDateTimeFormat4 = splitDateTimeFormat(format),
        dateFormat = _splitDateTimeFormat4.dateFormat,
        timeFormat = _splitDateTimeFormat4.timeFormat;

    return {
      dateText: formatValue(parsed, {
        generateConfig: generateConfig,
        locale: locale,
        format: dateFormat
      }),
      timeText: timeFormat ? formatValue(parsed, {
        generateConfig: generateConfig,
        locale: locale,
        format: timeFormat
      }) : ''
    };
  }

  return extractDateTimeText(text, format);
} // eslint-disable-next-line consistent-return

export function getCellDateDisabled(_ref4) {
  var cellDate = _ref4.cellDate,
      mode = _ref4.mode,
      disabledDate = _ref4.disabledDate,
      generateConfig = _ref4.generateConfig;
  if (!disabledDate) return false; // Whether cellDate is disabled in range

  var getDisabledFromRange = function getDisabledFromRange(currentMode, start, end) {
    var current = start;

    while (current <= end) {
      var date = void 0;

      switch (currentMode) {
        case 'date':
          {
            date = generateConfig.setDate(cellDate, current);

            if (!disabledDate(date)) {
              return false;
            }

            break;
          }

        case 'month':
          {
            date = generateConfig.setMonth(cellDate, current);

            if (!getCellDateDisabled({
              cellDate: date,
              mode: 'month',
              generateConfig: generateConfig,
              disabledDate: disabledDate
            })) {
              return false;
            }

            break;
          }

        case 'year':
          {
            date = generateConfig.setYear(cellDate, current);

            if (!getCellDateDisabled({
              cellDate: date,
              mode: 'year',
              generateConfig: generateConfig,
              disabledDate: disabledDate
            })) {
              return false;
            }

            break;
          }
      }

      current += 1;
    }

    return true;
  };

  switch (mode) {
    case 'date':
    case 'week':
      {
        return disabledDate(cellDate);
      }

    case 'month':
      {
        var startDate = 1;
        var endDate = generateConfig.getDate(generateConfig.getEndDate(cellDate));
        return getDisabledFromRange('date', startDate, endDate);
      }

    case 'quarter':
      {
        var startMonth = Math.floor(generateConfig.getMonth(cellDate) / 3) * 3;
        var endMonth = startMonth + 2;
        return getDisabledFromRange('month', startMonth, endMonth);
      }

    case 'year':
      {
        return getDisabledFromRange('month', 0, 11);
      }

    case 'decade':
      {
        var year = generateConfig.getYear(cellDate);
        var startYear = Math.floor(year / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF;
        var endYear = startYear + DECADE_UNIT_DIFF - 1;
        return getDisabledFromRange('year', startYear, endYear);
      }
  }
}
/** 检查时分秒是否被 disabledTime 禁用 */

export function isTimeDisabled(generateConfig, date, disabledTime) {
  var _disabledTimes$disabl, _disabledTimes$disabl2, _disabledTimes$disabl3, _disabledTimes$disabl4, _disabledTimes$disabl5, _disabledTimes$disabl6;

  if (!disabledTime || !date) {
    return false;
  }

  var disabledTimes = disabledTime(date);

  if (!disabledTimes) {
    return false;
  }

  var hour = generateConfig.getHour(date);
  var minute = generateConfig.getMinute(date);
  var second = generateConfig.getSecond(date);
  var disabledHours = (_disabledTimes$disabl = (_disabledTimes$disabl2 = disabledTimes.disabledHours) === null || _disabledTimes$disabl2 === void 0 ? void 0 : _disabledTimes$disabl2.call(disabledTimes)) !== null && _disabledTimes$disabl !== void 0 ? _disabledTimes$disabl : [];

  if (disabledHours.includes(hour)) {
    return true;
  }

  var disabledMinutes = (_disabledTimes$disabl3 = (_disabledTimes$disabl4 = disabledTimes.disabledMinutes) === null || _disabledTimes$disabl4 === void 0 ? void 0 : _disabledTimes$disabl4.call(disabledTimes, hour)) !== null && _disabledTimes$disabl3 !== void 0 ? _disabledTimes$disabl3 : [];

  if (disabledMinutes.includes(minute)) {
    return true;
  }

  var disabledSeconds = (_disabledTimes$disabl5 = (_disabledTimes$disabl6 = disabledTimes.disabledSeconds) === null || _disabledTimes$disabl6 === void 0 ? void 0 : _disabledTimes$disabl6.call(disabledTimes, hour, minute)) !== null && _disabledTimes$disabl5 !== void 0 ? _disabledTimes$disabl5 : [];

  if (disabledSeconds.includes(second)) {
    return true;
  }

  return false;
}